<template>
  <Modal v-model="modal" title="选择仓库" width="50" @on-cancel="cancels">
    <Form :model="queryParams" :label-width="110" inline>
      <FormItem label="仓库名称">
        <Input style="width:200px" v-model="queryParams.name" clearable placeholder="请输入" />
      </FormItem>
      <FormItem label="仓库所在地址">
        <Input style="width:200px" placeholder="请输入" clearable v-model="queryParams.addressLike" />
      </FormItem>
      <Button type="primary" @click="search">查询</Button>
    </Form>
    <data-grid ref="storage" :columns="cols" :queryParams="queryParams" :queryUrl="queryUrl" paramsName="param" subListName :pageNum="1" :pageSize="10" :dataList="[]">
      <template #default="{columns,data}">
        <Table :columns="columns" :data="data" border stripe size="small" highlight-row @on-current-change="currentRow => selectedStorage = currentRow"></Table>
      </template>
    </data-grid>
    <template #footer>
      <Button type="primary" @click="selectStorage">确定</Button>
    </template>
  </Modal>
</template>


<script>
import dataGrid from "@/components/datagrid.vue";
import dictSelect from "@/components/select/dict-select.vue";
import leaseeSelect from "@/components/select/payee-select.vue";

export default {
  props: {
    queryShow: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    dataGrid,
    leaseeSelect,
    dictSelect,
  },
  data() {
    return {
      modal: false,
      queryUrl:
        "CORE-STORAGE/messageService/baseInfoService/queryStorageBaseInfos",
      queryParams: {
        memberId: "",
        name: "",
        type: "",
        pageNum: "",
        pageSize: "",
        addressLike: "",
        disabled: 0,
      },
      selectedStorage: {},
      cols: [
        { title: "仓库编号", key: "id" },
        { title: "仓库名称", key: "nameWithDisabledFlag" },
        {
          title: "仓库联系人",
          key: "linkmanId",
          dict: ["bizObjects", "contact", true],
        },
        { title: "仓库所在地址", key: "address" },
        {
          title: "仓库类型",
          key: "type",
          dict: ["ENUM_CORE-STORAGE", "storageBaseInfo.StorageType", true],
        },
        {
          title: "参与人",
          key: "memberId",
          dict: ["bizObjects", "member", true],
        },
        { title: "创建时间", key: "createTime", formatter: "datetime" },
      ],
    };
  },
  methods: {
    openStorage(type, leaseeId, recycleMethod) {
      this.modal = true;
      let paramsType = type ? type : "";
      let paramsLeaseeId = leaseeId ? leaseeId : "";
      if (recycleMethod == "SELF_DELIVERY") {
        this.queryParams.memberId = "";
      } else {
        this.queryParams.memberId = paramsLeaseeId;
      }
      this.queryParams.type = paramsType;
      this.search();
    },
    search() {
      this.$refs["storage"].loadFirstPage();
    },
    selectStorage() {
      if (!this.selectedStorage.id)
        return this.$Notice.error({ title: "请选择仓库" });
      this.$emit("on-select-storage", this.selectedStorage);
      this.modal = false;
    },
    cancels() {
      this.queryParams = {
        memberId: "",
        name: "",
        type: "",
        pageNum: "",
        pageSize: "",
      };
    },
  },
};
</script>
